import React from 'react';
import styles from './CheckboxGroup.module.scss';
import { SelectOption } from '../../types';
import Checkbox from '../checkbox/Checkbox';

type Props = {
  value: string[];
  options: SelectOption[];
  onChange: (value: string[]) => void;
  hasError?: boolean;
  subTitle?: string;
  touchable?: boolean;
  needSpeak?: boolean;
  isAU?: boolean;
};

function CheckboxGroup(props: Props) {
  const { value, options, onChange, subTitle, hasError, touchable, needSpeak, isAU } = props;

  const handleChange = (o: SelectOption) => (selected: boolean) => {
    if (selected) {
      const exists = value.includes(o.value);
      if (!exists) {
        value.push(o.value);
        onChange([...value]);
      }
    } else {
      const index = value.findIndex(v => v === o.value);
      if (index !== -1) {
        value.splice(index, 1);
      }
      onChange([...value]);
    }
  };

  return (
    <div className={hasError ? styles.hasError : ''}>
      {options.map(o => {
        const checked = value.includes(o.value);

        return (
          <Checkbox key={o.value} id={o.value} checked={checked} onChange={handleChange(o)} label={o.label} touchable={touchable} needSpeak={needSpeak} isAU={isAU} />
        );
      })}
      {subTitle && <div className={styles.subtitle}>{subTitle}</div>}
    </div>
  );
}

export default CheckboxGroup;
